import React from 'react';
import classNames from 'classnames';

export default function CheckmarkIcon({ className = '', simple = true }) {
	return (
		<span
			className={classNames('icon', className, {
				'icon-checkmark': !simple,
				'icon-checkmark_simple': simple,
			})}
		/>
	);
}
